import { Dispatch, ReactElement, SetStateAction } from 'react';

import { ITab } from 'coreOld/types';

import { ChildrenWrapper, Wrapper } from './verticalTabsStyle';
import TabsNavigation from './TabsNavigation';

interface IProps {
  tabs: ITab[];
  activeTab: ITab;
  setActiveTab: Dispatch<SetStateAction<ITab>>;
  children?: ReactElement | ReactElement[];
}

const VerticalTabsView = ({ tabs, activeTab, setActiveTab, children }: IProps) => {
  return (
    <Wrapper>
      <TabsNavigation tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Wrapper>
  );
};

export default VerticalTabsView;
